export const FEATURES = [
	{
		id: 'SAMPLE',
		name: 'Sample',
		value: 'Sample'
	}
];

export const SEARCH_TYPE = [
	{
		id: 'DESIGN_NO',
		name: 'Search with Design No.',
		value: 'Design No.'
	},
	{
		id: 'QR_CODE',
		name: 'Search with QR Code',
		value: 'QR Code'
	}
];

export const COLOR_OPTIONS = [
	'#DBFFE5',
	'#FFEAEA',
	'#FBD9C2',
	'#FEEAC1',
	'#DFF2FF',
	'#EDE3FE',
	'#D0F0FD',
	'#F4DBE6',
	'#C2F5E9',
	'#EDDBD5'
];

export const SCAN_TYPE = {
	NEW_SAMPLE_SCAN: 'NEW_SAMPLE_SCAN',
	UPDATE_LOCATION: 'UPDATE_LOCATION',
	FETCH_LOCATION_SAMPLES: 'FETCH_LOCATION_SAMPLES',
	REPLACE_LOCATION: 'REPLACE_LOCATION',
	UNKNOWN: 'UNKNOWN'
};
